import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { classNames } from '@utils/genUtils'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  even: boolean
  image: IGatsbyImageDataObject
  cssModifier?: string
  containerCss?: string
}

function FacebookTestimonial(props: Props) {
  const {
    even, image, cssModifier, containerCss
  } = props
  const isEvenCss = even ? `lg:col-start-4 lg:col-span-8` : `lg:col-start-6 lg:col-span-8`
  return (
    <div className={twMerge(`col-start-2 col-span-2 md:col-start-3 md:col-span-10 ${isEvenCss}`, containerCss ?? '')}>
      <div className='p-4 overflow-hidden bg-white rounded-lg shadow-md'>
        <div className={cssModifier}>
          <GatsbyImage
            style={{ height: "100%", width: "100%" }}
            alt={`Facebook Testimonial`} image={image.gatsbyImageData} />
        </div>
      </div>
    </div>
  )
}

export default FacebookTestimonial
